/**
 * Welloura Product Stack — live-style card deck (prev / active / next transforms + loop).
 */
if (!customElements.get('wl-pd-stack-slider')) {
  class WlPdStackSlider extends HTMLElement {
    constructor() {
      super();

      this.slides = Array.from(this.querySelectorAll('[data-stack-slide]'));
      this.prevBtn = this.querySelector('[data-stack-prev]');
      this.nextBtn = this.querySelector('[data-stack-next]');
      this.dots = Array.from(this.querySelectorAll('[data-stack-dot]'));
      this.headingAccent = this.closest('.wl-pd-stack')?.querySelector('[data-stack-heading-accent]');
      this.watermark = this.closest('.wl-pd-stack')?.querySelector('[data-stack-watermark]');

      this.activeIndex = 0;
      this.count = this.slides.length;

      if (!this.count) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10) || 0));
      });

      this.update();
    }

    step(direction) {
      if (this.count < 2) return;
      const next = (this.activeIndex + direction + this.count) % this.count;
      this.goTo(next);
    }

    goTo(index) {
      if (index < 0 || index >= this.count) return;
      this.activeIndex = index;
      this.update();
    }

    prevIndex() {
      return (this.activeIndex - 1 + this.count) % this.count;
    }

    nextIndex() {
      return (this.activeIndex + 1) % this.count;
    }

    update() {
      const activeSlide = this.slides[this.activeIndex];
      const activeCard = activeSlide?.querySelector('[data-stack-title]');
      const activeColor =
        activeCard?.dataset.stackAccent ||
        getComputedStyle(document.documentElement).getPropertyValue('--optix').trim();
      const activeTitle = activeCard?.dataset.stackTitle || '';

      this.slides.forEach((slide, i) => {
        slide.classList.remove('is-active', 'is-prev', 'is-next');
        if (i === this.activeIndex) {
          slide.classList.add('is-active');
        } else if (this.count > 1 && i === this.prevIndex()) {
          slide.classList.add('is-prev');
        } else if (this.count > 1 && i === this.nextIndex()) {
          slide.classList.add('is-next');
        }
      });

      this.dots.forEach((dot, i) => {
        const on = i === this.activeIndex;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) {
          dot.style.setProperty('--wl-stack-dot-color', activeColor);
          dot.style.background = activeColor;
        } else {
          dot.style.background = '';
        }
      });

      if (this.headingAccent && activeTitle) {
        this.headingAccent.textContent = activeTitle;
        this.headingAccent.style.color = activeColor;
      }

      if (this.watermark && activeTitle) {
        this.watermark.textContent = activeTitle;
        /* live: stroke = accent + "08" (~3% alpha) */
        this.watermark.style.setProperty(
          '--wl-stack-watermark-stroke',
          this.hexToRgba(activeColor, 0.03)
        );
      }

      const root = this.closest('.wl-pd-stack');
      if (root) {
        root.style.setProperty('--wl-stack-heading-accent', activeColor);
      }
    }

    hexToRgba(hex, alpha) {
      const raw = (hex || '').replace('#', '').trim();
      if (raw.length !== 3 && raw.length !== 6) return `rgba(44, 72, 155, ${alpha})`;
      const full =
        raw.length === 3
          ? raw
              .split('')
              .map((c) => c + c)
              .join('')
          : raw;
      const n = parseInt(full, 16);
      const r = (n >> 16) & 255;
      const g = (n >> 8) & 255;
      const b = n & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }

  customElements.define('wl-pd-stack-slider', WlPdStackSlider);
}
